<template>
    <div class="authors-constructor">
        <div class="authors-constructor__list">
            <div
                v-for="(author, index) in viewAuthors"
                :key="author.id"
                class="authors-constructor__author"
            >
                <Grid :gap-y="0">
                    <Column :span="4">
                        <FormInput
                            v-model="author.first_name"
                            :placeholder="`Author ${index + 1} first name (required)`"
                            :required="index === 0"
                        />
                    </Column>
                    <Column :span="4">
                        <FormInput
                            v-model="author.last_name"
                            :placeholder="`Author ${index + 1} last name`"
                        />
                    </Column>
                    <Column :span="4">
                        <FormInput
                            v-model="author.patronymic"
                            :placeholder="`Author ${index + 1} patronymic`"
                        />
                    </Column>
                </Grid>
                <div class="authors-constructor__actions">
                    <button
                        v-if="viewAuthors.length > 1"
                        type="button"
                        class="button button--blank authors-constructor__remove"
                        :disabled="viewAuthors.length === 1"
                        @click="removeAuthor(author)"
                    >
                        ✕
                    </button>
                </div>
            </div>
        </div>
        <div class="authors-constructor__bottom">
            <button type="button" class="button button--blank" @click="addAuthor">
                <b>+ Add author</b>
            </button>
        </div>
    </div>
</template>

<script>
import { FormInput } from '@speechki-frontend/shared/ui/forms';
import { makeid } from '@speechki-frontend/shared/helpers/functions';

import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';

// should retur data in format [{ first_name, last_name, patronymic }]

function createLocalAuthors(authors) {
    return authors
        .map((author, index) => ({ ...author, order: index, id: makeid() }))
        .reduce((acc, author) => {
            acc[author.id] = {
                ...author,
            };
            return acc;
        }, {});
}

export default {
    name: 'AuthorsConstructor',
    components: {
        FormInput,
        Grid,
        Column,
    },

    props: {
        modelValue: {
            default: () => [],
            type: Array,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            localAuthors: createLocalAuthors(this.modelValue),
        };
    },

    computed: {
        viewAuthors() {
            return Object.values(this.localAuthors).sort((a, b) => a.order - b.order);
        },
        maxOrder() {
            return this.viewAuthors.reduce((result, author) => {
                result = Math.max(result, author.order);
                return result;
            }, 0);
        },
    },

    watch: {
        localAuthors: {
            deep: true,
            handler() {
                this.$emit(
                    'update:modelValue',
                    this.viewAuthors.map((author) => {
                        const { last_name, first_name, patronymic } = author;
                        return { last_name, first_name, patronymic };
                    })
                );
            },
        },
    },

    methods: {
        addAuthor() {
            const id = makeid();

            const author = {
                first_name: '',
                last_name: '',
                patronymic: '',
                id,
                order: this.maxOrder + 1,
            };

            this.localAuthors[id] = author;
        },
        removeAuthor(target) {
            delete this.localAuthors[target.id];
        },
        reset() {
            this.localAuthors = [];
            this.addAuthor();
        },
    },
};
</script>

<style lang="scss" src="./AuthorsConstructor.scss"></style>
